<template>
	<div class="recordOfOpening">
		<div class="step">
			<el-table :header-cell-style="{background:'#f0f3f8',color:'#333'}" :data="tableData" border
				style="width: 100%">
				<el-table-column prop="id" label="編號" width="80">
				</el-table-column>
				<el-table-column prop="mobile" label="手機號碼">
				</el-table-column>
				<el-table-column prop="content" label="留言内容">
					<template slot-scope="scope">
						<div class="content_cell" :title="scope.row.content">{{scope.row.content}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="created_at" label="留言時間">
				</el-table-column>
			</el-table>


			<el-pagination prev-text="上一頁" next-text="下一頁" class="pagination" hide-on-single-page
				@current-change="onCurrentChange" layout="prev, pager, next,jumper" :page-size="10" :total="pageCount">
			</el-pagination>
		</div>
		<Alert :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog"
			@on-confirm="confirmDialog" />
	</div>
</template>

<script>
	import feedback from '../assets/js/feedback'

	import Alert from '../components/alert'
	export default {
		components: {
			Alert
		},
		name: "feedback",
		...feedback
	}
</script>
<style scoped>
	.recordOfOpening>>>.el-pager li.active {
		color: white;
		border-radius: 0.02rem;
		background: #6681FA !important;
	}

	.recordOfOpening>>>.el-pagination {
		text-align: center;
	}

	.content_cell {
		width: 300px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}

	.pagination {
		padding-right: 24px;
		text-align: center;
		margin-top: 6px;
		background-color: #fff;
		display: flex;
		justify-content: flex-end;
	}
</style>
<style src="../assets/css/feedback.css" scoped>

</style>